/* Prices are integer cents. Shopify remains responsible for applied discounts. */
(function (root) {
  'use strict';
  function config() { return root.LPCPromo || {}; }
  function eligible(handle) { return (config().eligibleHandles || []).includes(handle); }
  function rate(qty) {
    var c = config();
    return qty >= c.promo_pack_min_qty ? Number(c.promo_pack_pct) : Number(c.promo_solo_pct);
  }
  function quote(units) {
    var count = units.filter(function (u) { return eligible(u.product.handle); }).length;
    var pct = rate(count), subtotal = 0, total = 0;
    units.forEach(function (u) {
      var price = Math.round(Number(u.variant.price));
      subtotal += price;
      total += config().active && eligible(u.product.handle) ? Math.round(price * (100 - pct) / 100) : price;
    });
    return { subtotal: subtotal, total: total, saving: subtotal - total };
  }
  function upgrade(existing, added) {
    return Math.max(0, quote(existing.concat(added)).total - quote(existing).total);
  }
  function text(key, values) {
    var value = config().i18n?.[key] || '';
    Object.keys(values || {}).forEach(function (k) { value = value.split('[' + k + ']').join(values[k]); });
    return value;
  }
  function renderTicket(host, options) {
    options = options || {};
    host.replaceChildren();
    if (!config().active || options.hidden) { host.hidden = true; return; }
    host.hidden = false;
    var doc = host.ownerDocument, ticket = doc.createElement('span');
    if (options.badgeOnly) {
      var badge = doc.createElement('span'); badge.className = 'lpc-bf-ticket__pct lpc-bf-badge--' + (options.tone || 'solo');
      badge.textContent = text('discount', {pct:options.pct}).replace(/\s*%/, '\u202f%'); host.append(badge); return;
    }
    var label = text(options.label === 'price' ? 'price_label' : options.label === 'promo' ? 'ticket_promo' : options.label === 'best' ? 'ticket_best' : 'ticket');
    ticket.className = 'lpc-bf-ticket lpc-bf-ticket--' + (options.size || 'sm') + ' lpc-bf-ticket--' + (options.tone || 'solo');
    ticket.setAttribute('role', 'img');
    ticket.setAttribute('aria-label', label + (options.pct != null ? ', ' + text('ticket_reduction', {pct:options.pct}) : ''));
    var caption = doc.createElement('span'); caption.className = 'lpc-bf-ticket__label';
    caption.textContent = label; caption.setAttribute('aria-hidden', 'true'); ticket.append(caption);
    if (options.pct != null) {
      var chip = doc.createElement('span'); chip.className = 'lpc-bf-ticket__pct';
      chip.textContent = text('discount', {pct:options.pct}).replace(/\s*%/, '\u202f%'); chip.setAttribute('aria-hidden', 'true'); ticket.append(chip);
    }
    host.append(ticket);
  }
  function stockText(variant) {
    var c = config();
    if (!c.stock_counts_live || !variant) return '';
    if (variant.available === false) return text('sold_out');
    if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity < c.stock_low_threshold) return text('low_stock', { count: variant.inventory_quantity });
    return '';
  }
  function syncStock(page, variant) {
    page.querySelectorAll('[data-lpc-stock-count]').forEach(function (el) {
      el.textContent = stockText(variant); el.hidden = !el.textContent;
    });
  }
  if (root.document) root.document.addEventListener('lpc:variant-change', function (event) {
    var source = root.document.querySelector('[data-bf-variants]');
    if (!source) return;
    var variant = JSON.parse(source.textContent).find(function (v) { return String(v.id) === String(event.detail?.variant); });
    if (variant) syncStock(root.document, variant);
  });
  var api = { renderTicket: renderTicket, config: config, eligible: eligible, rate: rate, quote: quote, upgrade: upgrade, text: text, stockText: stockText, syncStock: syncStock };
  root.LPCPromoPricing = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
